import { render } from "./SelectDispPlain.vue?vue&type=template&id=38e9381b"
import script from "./SelectDispPlain.vue?vue&type=script&lang=js"
export * from "./SelectDispPlain.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/SelectDispPlain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38e9381b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38e9381b', __exports__)) {
    console.log('reload')
    api.reload('38e9381b', __exports__)
  }
  
  module.hot.accept("./SelectDispPlain.vue?vue&type=template&id=38e9381b", () => {
    console.log('re-render')
    api.rerender('38e9381b', render)
  })

}


export default __exports__